import { AssignUserViewStore } from 'nomst/Stores/Configuration/assignUserView.store';
import { dataManagerFactory, configurationsStore } from 'utils/MobxDataManager/singletons';
import { EmployeeLevelEnum } from 'typings/enums';
import { IBaseEmployeeLevel } from 'typings/baseEmployeeLevel';
import { observable, computed, action, makeObservable } from 'mobx';

export class BaseEmployeeLevel {
    @observable level: EmployeeLevelEnum;
    @observable levelName: string;
    @observable isSelected: boolean;
    @observable hrReviewer: AssignUserViewStore;
    maid: string;

    constructor(dto: IBaseEmployeeLevel, maid: string) {
        makeObservable(this);
        this.level = dto.level;
        this.levelName = dto.levelName;
        this.isSelected = dto.isSelected ?? false;
        this.hrReviewer = new AssignUserViewStore('', '', '', maid, this.saveHrReviewerUser.bind(this), this.removeHrReviewerUser.bind(this));
        this.maid = maid;
    }

    @computed
    get accessGroupId(): string {
        return `${this.levelName.replace(' ', '')}${this.level.replace(' ', '')}`;
    }

    @computed
    get accessGroupDisplayName(): string {
        return `${this.levelName} ${this.level}`;
    }

    @computed
    get currentCycleId(): Nullable<number> {
        return configurationsStore?._currentCycleConfiguration?.cycleId ?? null;
    }

    @action
    async saveHrReviewerUser(userId: string): Promise<void> {
        const configurationDataManager = dataManagerFactory.getConfigurationDataManager();
        await configurationDataManager.saveHrReviewerUser(
            configurationsStore._masterAccountId,
            userId,
            [{level: this.level, levelName: this.levelName, isSelected: this.isSelected} as IBaseEmployeeLevel]);
    }

    async removeHrReviewerUser(): Promise<void> {
        const configurationDataManager = dataManagerFactory.getConfigurationDataManager();
        await configurationDataManager.removeHrReviewerUser(
            this.maid,
            this.level,
            this.levelName);
    }

    @action
    setSelection(selection: boolean): void {
        this.isSelected = selection;
    }

    @action
    toggleSelection(): void {
        this.isSelected = !this.isSelected;
    }
}